import { AnimatePresence, motion } from "motion/react";
import Icon from "../Icon";
import classNames from "classnames";
import { CSSProperties } from "react";

const NextSlideButton = ({
  slideDirection = "horizontal",
  direction = 1,
  centered = false,
  disabled = false,
  hidden = false,
  ariaHidden = false,
  onClick,
  style,
  id = "",
  returnIcon = false
}: {
  slideDirection?: "horizontal" | "vertical";
  direction?: 1 | -1;
  centered?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  ariaHidden?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
  id?: string;
  returnIcon?: boolean;
}) => {
  return (
    <AnimatePresence mode={"wait"}>
      <motion.div
        key={direction}
        aria-hidden={ariaHidden ? "true" : "false"}
        role={ariaHidden ? "presentation" : "button"}
        onClick={() => {
          disabled || onClick?.();
        }}
        initial={{ opacity: 0 }}
        animate={{
          opacity: disabled ? 0.25 : 1
        }}
        exit={{ opacity: 0 }}
        id={id || "next-button-" + (direction === -1 ? "left" : "right")}
        className={classNames("next-slide-button", {
          left: direction === -1 && slideDirection !== "vertical",
          right: direction === 1 && slideDirection !== "vertical",
          up: direction === -1 && slideDirection === "vertical",
          down: direction === 1 && slideDirection === "vertical",
          disabled: disabled,
          centered: centered,
          hidden: hidden,
          return: returnIcon && !disabled
        })}
        style={style}
        transition={{ duration: 0.5 }}
      >
        <Icon
          name={
            "arrow-" +
            (slideDirection === "vertical"
              ? direction === 1
                ? returnIcon && !disabled
                  ? "turn-left-up"
                  : "down"
                : returnIcon && !disabled
                ? "turn-left-down"
                : "up"
              : direction === 1
              ? returnIcon && !disabled
                ? "turn-down-left"
                : "right"
              : returnIcon && !disabled
              ? "turn-down-right"
              : "left")
          }
        />
      </motion.div>
    </AnimatePresence>
  );
};

export default NextSlideButton;
